export default __webpack_public_path__ + "static/map-dcf4fc9b00f56560e5df156a5c3348db.svg";